import error from '../log-error';

export default function getDocument() {
  if (!document) {
    error('could not find "document"');
    return null;
  }

  return document;
}
